var creditCardType = require('credit-card-type');
require('jquery.countdown');

var cc = require('./payments.js');

var chargeBee = function(cc){
    var cc = (cc == true) ? cc : false;
    var chargebeeInstance = Chargebee.init({
        site: "fibrenest-test"
    });

    var cbPortal = chargebeeInstance.createChargebeePortal();

    chargebeeInstance.setPortalSession(function(){
        // This should return a promise that resolves a portal session object.
        // If the library that you use for making ajax calls, can return a promise, you can directly return that.
        // We will discuss on how to implement this end point below.
        //return $.post("/dashboard/sso", {customer_id: accountId}).then((response) => response.data);
        return $.ajax({
            url: '/dashboard/sso',
            method: 'POST',
            data: {
                customer_id: accountId
            }
        }).done(function(data){
            console.table(data);
        });
    });

    cbPortal.open({
        close: function() {
            if(!cc) {
                alert('You have cancelled the direct debit setup process. Please re-open this window if you wish to proceed with the installation.');
            }
        },
        paymentSourceAdd: function(evt) {
            console.table(arguments);
            if(!cc) {
                $('#payment-method-add').submit();
            }
            else {
                cbPortal.closeAll();
            }
            // Optional
            // called whenever a new payment source is added in portal
        },
    });
};

var directDebitCheck = function(){
    // Load a URL that will query the database and see if we have a mandate
  var jqxhr = $.ajax({
    url: '/dashboard/check-mandate',
    type: 'post',
    data: 'acc='+accountId
  }).done(function(data){
      if(data.success) {
        // we have a mandate, we can refresh the next page
        //window.location = '/dashboard/directdebit-confirm';
        $('input[name="direct_debit"]').val(1);
        $('#payment-method-add').submit();
      }
      else {
          console.log('Nothing to do...');
      }
  });
};

module.exports = {
    creditCard: {
        _init: function(){
            cc.cc();
            //chargeBee(true);
            // var OBJ = this;
            //
            // // check the length of the form field and attempt to verify
            // if($('#cardNumber').val().length > 0) {
            //     OBJ._valididate($('#cardNumber'));
            // }
            //
            // $('#cardNumber').not('.js-ignore').on('keyup', function(){
            //     var $this = $(this);
            //     OBJ._valididate($this);
            //
            // }).on('paste', function(){
            //     var $this = $(this);
            //     OBJ._valididate($this);
            // }).addClass('js-ignore');
        },

        // _valididate: function($el){
        //     var OBJ = this;
        //     var num = $el.val();
        //     var $helper = $el.parents('.form-group').find('.cc-helper');
        //     if(num.length > 0) {
        //         var cardTypes = creditCardType(num);
        //         if(cardTypes.length == 1 ) {
        //             var cardType = cardTypes[0];
        //             var type = cardType.type;
        //             OBJ._removePaymentTypes($helper);
        //             $helper.addClass('card-type-'+type);
        //         }
        //     }
        //     else {
        //         OBJ._removePaymentTypes($helper);
        //         $helper.addClass('card-type-credit');
        //     }
        // },

        // _removePaymentTypes: function($el) {
        //     $el.removeClass('card-type-credit')
        //         .removeClass('card-type-visa')
        //         .removeClass('card-type-master-card')
        //         .removeClass('card-type-discover')
        //         .removeClass('card-type-american-express')
        //         .removeClass('card-type-jcb')
        //         .removeClass('card-diners-club')
        //         .removeClass('card-type-visa')
        //         .removeClass('card-type-unionpay')
        //         .removeClass('card-type-maestro');
        // }
    },
    view: {
        _init: function(){

          const swiper = new Swiper('.swiper', {
            direction: 'horizontal',
            loop: true,
            autoplay: {
              delay: 5000,
              disableOnInteraction: true,
            },
            parallax: true,
            keyboard: {
              enabled: true,
            },
            slidesPerView: 1,
            spaceBetween: 16,
            speed: 1500,
            pagination: {
              el: '.swiper-pagination',
              clickable: true,
            },
            effect: "creative",
            creativeEffect: {
              prev: {
                shadow: false,
                opacity: 0,
                translate: ["-120%", 0, -500],
              },
              next: {
                shadow: false,
                opacity: 0,
                translate: ["120%", 0, -500],
              },
            },
          });

          if($('.nine-hundred-mb-footer')){
            $('.nine-hundred-mb-footer .btn').on('click', function(){
              $.ajax({
                url: '/upgrade-package/900',
                type: 'post',

              }).done(function(){
                $('#nine-hundred-mb-modal').modal('show');
              })
            })
          }

            if(typeof serviceActivated != 'undefined') {
              var targetDate = new Date(serviceActivated * 1000);
              targetDate.setMinutes( targetDate.getMinutes()+10 );
              if(targetDate.getTime() >= new Date().getTime()) {
                $('div#countdown').countdown(targetDate, function(event) {
                  $(this).html(event.strftime('%M:%S'))
                }).on('finish.countdown', function () {
                  $('div#countdown').text('Service Active');
                  $('.hide-on-active').fadeOut('fast');
                });
              }
              else {
                $('div#countdown').text('Service Active');
                $('.hide-on-active').fadeOut('fast');
              }
            }

          if(typeof UCR != 'undefined') {
            var cookieValue = document.cookie.replace(/(?:(?:^|.*;\s*)fibrenest_sign_site_status\s*\=\s*([^;]*).*$)|^.*$/, "$1");
            if(!cookieValue) {
              if(UCR.length > 0) {
                $('#check-service-status').click();
              }
            }
          }
        }
    },
    directDebit: {
        _init: function () {
            //chargeBee();
          $('[data-target]').not('js-ignore').on('click', function(){
              window.open($(this).data('target'), '', 'menubar=no,toolbar=no,resizable=no,location=no,status=no`');

              return false;
          }).addClass('js-ignore');

          // check if we have a new payment method...
          $(window).on('focus', function(){
            directDebitCheck();
          });
        }

    },
    directdebit: {
        _init: function() {
            module.exports.directDebit._init();
        }
    },
    directdebitConfirm: {
        _init: function() {
            $('#cc').on('change', function(){
                if( $(this).prop('checked') ) {
                    $('#confirmSubmit').val('Continue and pay by Credit Card');
                }
                else {
                    $('#confirmSubmit').val('Continue to sign contract');
                }
            });
        }
    },
    directdebitconfirm: {
      _init: function() {
        module.exports.directdebitConfirm._init();
      }
    },
    contractinformation: {
      _init: function() {
        $('c-i-download').on('click',function() {

        });
        
      }
    },
    contract: {
      _init: function() {
        
        $('#key-facts').on('click',function() {
          $('.key-facts-modal').removeClass('show');
          $('.key-facts-blur').css('display','none');
          $('#contract-form').prepend('<input type="hidden" name="key_facts" value="1">');
        });
        
        $('.key-facts-lock').on('scroll',function() {
          // check status of scroll.
          
          if (this.scrollHeight - this.clientHeight - this.scrollTop < 17) 
          {
            
            $('#contract-form').prepend('<input type="hidden" name="scroll_facts" value="1">');
            
            if ($("input[name=scroll_facts]").val() == 1)
            {
              $unlock = true;
              if (($("input[name=voice-status]").val() == 1) && $('#voice-facts')[0].checked == false)
              {
                $unlock = false;
              }
              if  (($("input[name=fibre-status]").val() == 1) && $('#fibre-facts')[0].checked == false)
              {
                $unlock = false;
              }

              // unlock key-facts button
              if ($unlock)
                $('#key-facts').removeAttr('disabled');
            }
          } 

        });

        $('#fibre-facts').on('change',function() {
          // check if selected 
          if (this.checked == true)
          {
            $('#contract-form').prepend('<input type="hidden" name="fibre_facts" value="1">');
            
          } else {
            $('#contract-form').prepend('<input type="hidden" name="fibre_facts" value="0">');
            if (!$('#key-facts').attr('disabled'))
            {
              $('#key-facts').attr('disabled',true);
            }
          }
          
          // check if key facts is selected and scroll is true
          if ($("input[name=scroll_facts]").val() == 1)
          {
            $unlock = true;
            if (($("input[name=voice-status]").val() == 1) && $('#voice-facts')[0].checked == false)
            {
              $unlock = false;
            }
            if  (($("input[name=fibre-status]").val() == 1) && $('#fibre-facts')[0].checked == false)
            {
              $unlock = false;
            }

            // unlock key-facts button
            if ($unlock)
              $('#key-facts').removeAttr('disabled');
          }
          
        });

        $('#voice-facts').on('change',function() {
          // check if selected 
          if (this.checked == true)
          {
            $('#contract-form').prepend('<input type="hidden" name="voice_facts" value="1">');
            
          } else
          {
            $('#contract-form').prepend('<input type="hidden" name="voice_facts" value="0">');
            if (!$('#key-facts').attr('disabled'))
            {
              $('#key-facts').attr('disabled',true);
            }
          }
          
          // check if key facts is selected and scroll is true
          if ($("input[name=scroll_facts]").val() == 1)
          {
            $unlock = true;
            if (($("input[name=voice-status]").val() == 1) && $('#voice-facts')[0].checked == false)
            {
              $unlock = false;
            }
            if  (($("input[name=fibre-status]").val() == 1) && $('#fibre-facts')[0].checked == false)
            {
              $unlock = false;
            }

            // unlock key-facts button
            if ($unlock)
              $('#key-facts').removeAttr('disabled');
          }
          
        });


        

      }
    }
}